<template>
  <div class="competence-block">
    <div class="competence-block__title">
      <drag-title-block
        class="competence-block__drag sortable-handle handleClass"
        :title="`${$tr('vacancy.preferences.competences.competence')} #${index + 1}`"
      />

      <div
        v-tooltip.top-center="$tr('common.iconTooltips.deleteCompetence')"
        class="competence-block__delete"
        @click="handleRemoving"
      >
        <i class="icon icon-recycle_bin"></i>
      </div>
    </div>

    <div class="competence-block__body">
      <vinput ref="input" v-model="name" :class="{ error: errors.has('competence') }" border :error="error" />

      <br />

      <a v-if="!hintEnabled && !hint" class="add-hint-button" @click.prevent="enableHint">
        {{ $tr('common.tooltips.add_button') }}
      </a>

      <transition name="fade">
        <div v-if="hintEnabled || hint" class="block-tooltip">
          <vtextarea
            v-model="hint"
            :class="{ error: errors.has('competence'), 'tooltip-textarea': true }"
            border
            :error="error"
            :placeholder="$tr('common.tooltips.add_placeholder')"
          />
          <a class="block-tooltip__close-button" href="#" @click="deleteHint">&#215;</a>
        </div>
      </transition>
    </div>

    <modal-remove v-if="is_visible_modal" @remove="remove" @cancel="toggle_modal" />
  </div>
</template>

<script>
import modalRemove from './ModalRemove.vue';
import DragTitleBlock from '@/routes_new/inner/vacancy/components/DragTitleBlock';

export default {
  name: 'VacancyPreferencesCompetenciesRow',

  components: {
    modalRemove,
    DragTitleBlock
  },

  props: {
    model: Object,
    index: Number
  },

  data() {
    return {
      is_visible_modal: false,
      hintEnabled: false
    };
  },

  computed: {
    name: {
      get() {
        return this.model.name;
      },

      set(name) {
        this.$store.commit('vacancy/updateCompetence', { ...this.model, name });
      }
    },

    hint: {
      get() {
        return this.model.hint;
      },

      set(hint) {
        this.$store.commit('vacancy/updateCompetence', { ...this.model, hint });
      }
    },

    valid() {
      return Object.keys(this.fields)
        .map(k => this.fields[k])
        .every(f => f.valid === true);
    },

    error() {
      if (!this.name) {
        return this.$tr("vacancy.preferences.competences.emptyQuestion");
      }

      return '';
    }
  },

  watch: {
    valid(isValid) {
      this.$store.commit("vacancy/competenceIsValid", {
        index: this.index,
        isValid
      });
    }
  },

  methods: {
    deleteHint() {
      this.hint = ``;
      this.hintEnabled = false;
    },

    enableHint() {
      this.hintEnabled = true;
    },

    deleteCompetence() {
      this.$store.commit('vacancy/deleteCompetence', this.model);
      this.$store.commit('vacancy/deleteCompetenceValidation', this.index);
    },

    handleRemoving() {
      this.toggle_modal();
    },

    toggle_modal() {
      this.is_visible_modal = !this.is_visible_modal;
    },

    remove() {
      this.toggle_modal();
      this.deleteCompetence();
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/fonts.scss';

.competence-block {
  background: #fff;
  position: relative;
  box-shadow: $box-shadow;
  margin-bottom: 20px;
  border-radius: 4px;

  &__title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid $grey-light;
  }

  &__drag {
    flex: 1;
  }

  &__delete {
    width: 47px;
    height: 47px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    font-size: 24px;
    color: $red;
    background: $background;
    transition: all ease-in-out 0.3s;

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }

    &:hover {
      background: $red-light;
      color: $white;
      transition: all 0.3s;
    }
  }

  &__body {
    padding: 20px;
  }
}

.block-title {
  flex: 1;
  margin-left: 0;

  h2 {
    margin: 0;
    padding: 0 0 10px !important;
    font-style: normal;
    font-weight: 500;
    font-size: 22px;
    line-height: 32px;
    color: #233346;
  }

  input {
    box-sizing: border-box;
    max-width: 100%;
    min-width: 100%;
    min-height: 38px;
    max-height: 200px;
    padding: 8px;
  }
}

.align-to-top {
  align-items: flex-start;
  justify-content: flex-start;
}

.vbutton {
  margin-top: 35px;
}

.comp-row {
  position: relative;
  display: flex;
  align-items: center;
}

.comp-row-btn {
  position: absolute;
  top: 52px;
  right: -64px;
  min-width: 40px;
  max-width: 40px;
  min-height: 40px;
  max-height: 40px;
  cursor: pointer;
  color: #7F8B99;
  transition: color ease-in-out .4s;

  &:hover {
    color: #607182;
  }
}

.add-hint-button {
  display: inline-flex;
  margin-top: -4px;
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 22px;
  color: #9FAAB6;
}

.block-tooltip {
  position: relative;
  margin-top: -6px;

  .block-tooltip__close-button {
    position: absolute;
    right: 7px;
    top: -4px;
    color: #7F8B99;
    font-size: 33px;
    font-weight: 300;
    transition: color ease-in-out .4s;

    &:hover {
      color: #607182;
    }
  }

  ::v-deep .vtextarea .textarea {
    padding: 10px 12px;
  }
}

.tooltip-textarea {
  height: 100px;
}
</style>
